const state = {
  id: '',
  isShowing: false
}

export default state
